import { useCallback, useEffect, useRef, useState } from 'react';
import authedFetch from '../../../lib/authedFetch';

const API = process.env.REACT_APP_BACKEND_URL;

// Big-screen side of the presenter remote: opens a session, polls for phone commands, publishes tour state.
export function useTourRemote(enabled, state, onCommand) {
  const [code, setCode] = useState('');
  const [phoneOnline, setPhoneOnline] = useState(false);
  const [error, setError] = useState('');
  const seq = useRef(0);
  const cb = useRef(onCommand);
  cb.current = onCommand;

  useEffect(() => {
    if (!enabled) { setCode(''); setPhoneOnline(false); return undefined; }
    let dead = false;
    authedFetch(`${API}/api/mirror/frontline/remote/sessions`, { method: 'POST' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`remote ${r.status}`))))
      .then((d) => { if (!dead) { seq.current = 0; setCode(d.code); setError(''); } })
      .catch(() => { if (!dead) setError('Could not start the remote'); });
    return () => { dead = true; };
  }, [enabled]);

  useEffect(() => {
    if (!code) return undefined;
    let dead = false;
    const tick = async () => {
      try {
        const r = await authedFetch(`${API}/api/mirror/frontline/remote/sessions/${code}?since=${seq.current}&role=screen`);
        if (!r.ok) throw new Error(String(r.status));
        const d = await r.json();
        if (dead) return;
        setPhoneOnline(!!d.phone_online);
        d.commands.forEach((c) => { seq.current = Math.max(seq.current, c.seq); cb.current(c.cmd); });
      } catch { if (!dead) setPhoneOnline(false); }
    };
    tick();
    const t = setInterval(tick, 700);
    return () => { dead = true; clearInterval(t); };
  }, [code]);

  const push = useCallback((s) => { if (code) authedFetch(`${API}/api/mirror/frontline/remote/sessions/${code}/state`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(s) }).catch(() => {}); }, [code]);
  const key = JSON.stringify(state);
  useEffect(() => { if (code) push(JSON.parse(key)); }, [code, key, push]);

  const url = code ? `${window.location.origin}/mirror/frontline/remote/${code}` : '';
  return { code, url, phoneOnline, error };
}
